<template>
  <div :class="['i-radio-group', groupClass]">
    <component :is="layoutTag" :class="rowClass">
      <template v-for="option in options" :key="getOptionKey(option)">
        <component
          :is="columnTag"
          v-bind="useRow ? option.colProps || defaultColProps : {}"
          :class="useRow ? option.colClass : option.wrapperClass"
        >
          <div
            :class="[
              option.itemClass || itemClass,
              { [activeClass]: isSelected(option) }
            ]"
            @click="!isDisabled(option) && handleChange(option.value)"
          >
            <v-radio
              :input-value="isSelected(option)"
              :disabled="isDisabled(option)"
              :name="resolvedName"
              @change="() => handleChange(option.value)"
            >
              <template v-if="$slots.label" #label>
                <slot name="label" :option="option">{{ option.label }}</slot>
              </template>
              <template v-else #label>
                {{ option.label }}
              </template>
            </v-radio>
          </div>
        </component>
      </template>
    </component>
  </div>
</template>

<script>
export default {
  name: 'LegacyRadioGroup',

  compatConfig: {
    COMPONENT_V_MODEL: false
  },

  props: {
    activeClass: {
      type: String,
      default: 'item-div-active'
    },
    defaultColProps: {
      type: Object,
      default: () => ({ cols: '12', md: '4', class: 'pb-0' })
    },
    disabled: {
      type: Boolean,
      default: false
    },
    groupClass: {
      type: [String, Array, Object],
      default: null
    },
    itemClass: {
      type: String,
      default: 'item-div-mini mb-0'
    },
    modelValue: {
      type: [String, Number, Boolean, Object],
      default: null
    },
    name: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      required: true
    },
    rowClass: {
      type: [String, Array, Object],
      default: null
    },
    useRow: {
      type: Boolean,
      default: true
    }
  },

  emits: ['update:modelValue', 'input', 'change'],

  data() {
    return {
      fallbackName: `legacy-radio-${Math.random().toString(36).slice(2)}`
    }
  },

  computed: {
    columnTag() {
      return this.useRow ? 'v-col' : 'div'
    },

    layoutTag() {
      return this.useRow ? 'v-row' : 'div'
    },

    resolvedName() {
      return this.name || this.fallbackName
    }
  },

  methods: {
    getOptionKey(option) {
      return option.key ?? option.value
    },

    handleChange(value) {
      if (this.disabled || this.modelValue === value) return

      this.$emit('update:modelValue', value)
      this.$emit('input', value)
      this.$emit('change', value)
    },

    isDisabled(option) {
      return this.disabled || !!option.disabled
    },

    isSelected(option) {
      return this.modelValue === option.value
    }
  }
}
</script>

<style lang="scss" scoped>
.item-div,
.item-div-mini {
  position: relative;
  cursor: pointer;
}
</style>
